import { parseInt } from 'lodash-es'
import { makeAutoObservable } from 'mobx'
import type { DateStr } from 'src/types'

export class WorkbookScoringDTO {
  studentWorkbookProgressId: number //학생-교재 페이지 id
  workbookProblemId: number // 교재 문제 id
  userAnswer: string | null // 유저 답
  result: 'NONE' | 'CORRECT' | 'WRONG' | 'UNKNOWN' //정답 여부 (  CORRECT: 정답, WRONG: 오답, NONE: 미채점 )
  updateDatetime: DateStr<'-'>
  assists: res.StudentWorkbookPageDetail['scoring']['assists']

  constructor(params: res.StudentWorkbookPageDetail['scoring']) {
    makeAutoObservable(this)
    this.studentWorkbookProgressId = params.studentWorkbookProgressId
    this.workbookProblemId = params.workbookProblemId
    this.userAnswer = params.userAnswer
    this.result = params.result
    this.updateDatetime = params.updateDatetime
    this.assists = params.assists
  }

  get id() {
    return WorkbookScoringDTO.encodeId(this)
  }

  get decodedId() {
    return WorkbookScoringDTO.decodeId(this.id)
  }

  static encodeId({
    studentWorkbookProgressId,
    workbookProblemId,
  }: Pick<WorkbookScoringDTO, 'studentWorkbookProgressId' | 'workbookProblemId'>) {
    return studentWorkbookProgressId + '-' + workbookProblemId
  }

  static decodeId(scoringId) {
    const [studentWorkbookProgressId, workbookProblemId] = scoringId.split('-')
    return {
      studentWorkbookProgressId: parseInt(studentWorkbookProgressId),
      workbookProblemId: parseInt(workbookProblemId),
    }
  }
}
